// Endorsements drawn from signed expert recommendation letters.
// Quotes are condensed from the letters' own language; attributions are accurate.
export const endorsementsData = [
    {
        id: 1,
        quote: "No single person has more influence over our technology direction, system architecture, and engineering execution. He is the architect and hands-on implementor of the systems our entire commercial operation depends upon.",
        name: 'Jeffrey Farrington',
        title: 'President',
        org: 'Assured Techmatics · ELD Solutions',
        initials: 'JF',
    },
    {
        id: 2,
        quote: "His contributions were part of the foundational infrastructure that gave PoLTE its production viability, and ultimately the technical value Qualcomm acquired. He represents the top tier of engineering talent in distributed systems and applied AI.",
        name: 'Andrew Wolverton',
        title: 'Principal Engineering Manager',
        org: 'Qualcomm · former CTO, PoLTE',
        initials: 'AW',
    },
    {
        id: 3,
        quote: "It is rare to encounter an engineer who combines Ravi's breadth of platform expertise with the depth to build production-grade implementations across full technology stacks. His contributions reflect extraordinary ability in his field.",
        name: 'Sunil Sankaramanchi',
        title: 'Chief Executive Officer',
        org: 'Wenable Inc.',
        initials: 'SS',
    },
];
